
import { mapGetters } from 'vuex'

import card from '~/mixins/card'
import * as aep from '~/util/aep-recommendation'
export default {
    mixins: [card],
    props: {
        magicUrl: {
            type: String,
            default: '/'
        },
    },
    data () {
        return {
            enrollModal: false,
            enrollPlan: null,
        }
    },
    computed: {
        ...mapGetters([
            'uid',
            'surveyRoutesMap',
            'isPlanInOpportunities',
            'summarySwitchedOnCardsCombos',
            'fullservePlus',
        ]),
        agentStorePlans () {
            // every option's agent-enrollable plans, each once (round-2 spec §13.2)
            return (this.aepContext ? aep.agentPlansAll(this.aepContext) : []).map(p => this.summaryPlansMap[p.id]).filter(Boolean)
        },
        // One block per option: header, the plan names (several options only),
        // the agent-enrollable store plans and that option's notes. An option
        // with nothing to click and nothing to say (all kept) has no block.
        optionBlocks () {
            const all = this.aepContext ? aep.options(this.aepContext) : []
            const multi = all.length > 1
            return all.map(o => ({
                option: o.option,
                header: multi ? `Enroll In Option ${o.option}` : 'Enroll In Recommended Coverage',
                names: multi ? o.resulting.map(p => p.name).join(' + ') : null,
                plans: o.agentPlans.map(p => this.summaryPlansMap[p.id]).filter(Boolean),
                notes: aep.actionsNotes(o),
            })).filter(b => b.plans.length || b.notes.holdPdp || b.notes.selfNames.length)
        },
    },
    methods: {
        isPlanCommissionable (plan) {
            return this.$store.getters.isPlanCommissionable(plan)
        },
        shouldAgentEnrollPlan (plan) {
            return this.isPlanIncluded(plan) && (this.isPlanCommissionable(plan) || this.fullservePlus) && this.isPlanAgentEnrollable(plan)
        }
    }
}
